import { StorySection } from './StorySection'
import { withStorySection } from './withStorySection'

const ConnectedStorySection = withStorySection(StorySection)
export { ConnectedStorySection as StorySection }
